import { TextSmall } from '@/components/Texts';
import React from 'react';

const LegalObligationTransmitCertainData = () => {
  return (
    <>
      <TextSmall fontWeight={700}>
        (11) Legal obligation to transmit certain data
      </TextSmall>
      <TextSmall>
        We may be subject to a specific legal or statutory obligation to provide
        the lawfully processed personal data to third parties, in particular
        public bodies (Art. 6 para. 1 p. 1 lit. c GDPR).
      </TextSmall>
    </>
  );
};

export default LegalObligationTransmitCertainData;
